"use client";

import Feature4Tile from "./Feature4Tile";

export default function Feature4TilesBlock({ slice }) {
  return (
    <div className="lg:grid lg:grid-cols-3 2xl:grid-cols-[1fr_minmax(0px,_480px)_1fr]">
      {slice.primary?.feature_items.map((item, idx) => {
        return (
          <Feature4Tile key={`feature_4_${idx}`} index={idx} data={item} />
        );
      })}
    </div>
  );
}
